import jwt_decode from "jwt-decode";

export default {

    // デコード
    decode(token) {
        return jwt_decode(token);
    }
}